const AssistantConfigSchema = {
  parse(input: unknown): { assistantEnabled: boolean } {
    if (!input || typeof input !== "object") return { assistantEnabled: false };
    if (!("assistantEnabled" in input)) return { assistantEnabled: false };
    const value = input.assistantEnabled;
    return { assistantEnabled: value === true };
  },
};

export async function fetchAssistantEnabled(): Promise<boolean> {
  try {
    const response = await fetch("/api/assistant/config", { headers: { accept: "application/json" } });
    if (!response.ok) return false;
    const json: unknown = await response.json();
    return AssistantConfigSchema.parse(json).assistantEnabled;
  } catch {
    return false;
  }
}
